// extracted by mini-css-extract-plugin
export default {"root":"CheckBox_root__dXgjO","labelClass":"CheckBox_labelClass__VegA2","text":"CheckBox_text__xIkPW","input":"CheckBox_input__y2Ecb"};